const Input = ({
  name,
  type,
  value,
  label,
  onChange,
  placeHolder,
  disabledStatus = false,
}) => {
  return (
    <div className="form-group">
      <label htmlFor={name}>{label}</label>
      <input
        type="text"
        onChange={onChange}
        value={value}
        className="form-control"
        name={name}
        id={name}
        placeholder={placeHolder}
        disabled={disabledStatus}
      />
    </div>
  );
};

export default Input;
